module.exports = "https://static.web-explore.prod.greetz-nl.net/_next/static/images/upcoming-occasion-mascot-907b992516ee3fe5a6b9447c41093d6b.png";